import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from "@angular/router";
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ProfileService } from '../../core/services/profile.service';
import { SidebarService } from '../../core/services/sidebar.service';
import { TagManagerService } from '../../core/services/tag-manager.service';
import { Widget } from './widget';

@Component({
    selector: 'app-widget',
    templateUrl: './widget.component.html',
    styleUrls: ['./widget.component.scss'],
    standalone: false
})
export class WidgetComponent {
    @Input('widget-meta') data: Widget;
    @Input() widgetTitle: string;
    @Input() widgetSubtitle: string;
    @Input() itemCount: number;
    @Input() alertCount: number;
    @Input() externalLink: string;
    @Input() internalLink: string;
    @Input() externalLinkText: string;
    @Input() showHelp: boolean;
    @Input() isModal: boolean = false;
    @Output() resizeTo = new EventEmitter<number>();
    @Output() isCollapsed = new EventEmitter<boolean>();
       
    constructor(
        private profileService: ProfileService,        
        public sidebarService: SidebarService,
        public router: Router,
        public gtm: TagManagerService,
        public activeModal: NgbActiveModal,
    ) {}

    public get title(): string {
        return this.profileService.labelLookup[this.data.meta.Name];
    }

    // Only show the widget if we have its metadata. If it's on the dashboard, then it also must be
    // favorited to be shown
    public get isVisible(): boolean {
        return (this.data && ( !this.isOnDashboard || this.data.IsFave )); 
    }

    public resizeWidget(newSize: number) {
        if (this.data.Size != newSize) {
            this.data.Size = newSize;
            this.gtm.gaWidgetResize(this.data);          
            this.resizeTo.emit(newSize);
            this.saveWidget();
        }
    }

    public toggleFavorite() {        
        this.data.IsFave = !this.data.IsFave;
        this.gtm.gaWidgetFave(this.data); 
        this.saveWidget(); 
    }

    public toggleCollapse() {
        this.data.IsCollapsed = !this.data.IsCollapsed;
        this.isCollapsed.emit(this.data.IsCollapsed);
        this.gtm.gaWidgetCollapse(this.data);
        this.saveWidget();      
    }

    private get isOnDashboard() {
        //  If we're in MyKE V2 we don't need to worry about checking the dashboard widgets for IsFave anymore
        return (this.router.url.endsWith('dashboard') && (this.profileService.profile.version != 2)); 
    }

    private saveWidget() {
        this.profileService.updateWidgetPreference(this.data.meta);
    }
}
